import React from 'react'
import Landing from '../routes/landings/Backyard'

const Backyard = () => {
  return <Landing />
}

export default Backyard
